import CheckboxField from "../components/radio-butoms/radioButom";
import NumbersField from "../components/number-fields/numbers-field";
import { FormProps, InputTypes } from "../components/textFieldProps";
import MoneyField from "../components/money-fields/money-field";
import SelectField from "../components/select-field/select-field";
import valorSolicitado from "../components/select-field/utilities/valor-solicitado";
import indispensable from "../components/select-field/utilities/indispensable";
import riesgo from "../components/select-field/utilities/riesgo";
import plazoFinal from "../components/select-field/utilities/plazo-final";
import plazoSolicitado from "../components/select-field/utilities/plazo-solicitado";

export default function FormularioInversionYDistribuidor({formulario, setFormulario, editable}: {formulario : any, setFormulario : any, editable: boolean}) {

    return (
        <>  
            <div className="flex grid grid-cols-2 gap-4">
                <Valor model={formulario} setModel={setFormulario} editable={editable}/>
                <div className="mt-9">
                    <ValorSolicitado model={formulario} setModel={setFormulario}  editable={editable}/>
                </div>
            </div>
            <div className="flex grid grid-cols-2 gap-4 mt-8">
                <PlazoSolicitado model={formulario} setModel={setFormulario} editable={editable}/>
                <PlazoFinal model={formulario} setModel={setFormulario} editable={editable}/>
            </div>
            <div className="flex grid grid-cols-2 gap-4 mt-8">
                <NecesidadAdquisicion model={formulario} setModel={setFormulario} editable={editable}/>
                <IngresosAdicionales model={formulario} setModel={setFormulario} editable={editable}/>
            </div>
            <div className="flex grid grid-cols-2 gap-4 mt-8">
                <VentasAnualesDistribuidor model={formulario} setModel={setFormulario} editable={editable}/>
                <ComportamientoCarteraDistribuidor model={formulario} setModel={setFormulario} editable={editable}/>
                <div className="mt-8 mb-32">
                    <Coberturas model={formulario} setModel={setFormulario} editable={editable}/>
                </div>
            </div>
        </>
    );
}

const Valor = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <MoneyField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='value'
            campoIdRespuesta='finance_percentage_score'
            placeholder='Valor del activo'
            title={'Exposición Final'}
            tooltip={<>Valor del activo: Valor diligenciado en el campo de<br></br> Valor Máquina de Pre-Aprobados o consultar cotización.<br></br><br></br> Valor solicitado: Valor seleccionado en el campo<br></br>de Porcentaje a Financiar de Pre-Aprobados</>}
            type={InputTypes.Money}
            editable={editable}
        />
    )
}

const ValorSolicitado = ({model : formulario, setModel : setFormulario, editable}: FormProps) => {
    return (
        <SelectField
            required={true}
            model={formulario}
            setModel={setFormulario}
            campoId='financial_percent'
            campoIdRespuesta='financial_percent'
            type={InputTypes.Number}
            placeholder='Porcentaje a financiar'
            editable={editable}
            options={valorSolicitado}
        />
    )
}

const PlazoSolicitado = ({model : formulario, setModel : setFormulario, editable}: FormProps) => {
    return (
        <SelectField
            required={true}
            model={formulario}
            setModel={setFormulario}
            campoId=''
            type={InputTypes.Number}
            title={'Plazo Solicitado'}
            placeholder='Plazo Solicitado'
            editable={editable}
            options={plazoSolicitado}
        />
    )
}

const PlazoFinal = ({model : formulario, setModel : setFormulario, editable}: FormProps) => {
    return (
        <SelectField
            required={true}
            model={formulario}
            setModel={setFormulario}
            campoId='deadline'
            title={'Plazo Final'}
            placeholder={"Plazo Final"}
            type={InputTypes.Number}
            editable={editable}
            options={plazoFinal}
        />
    )
}

const NecesidadAdquisicion = ({model : formulario, setModel : setFormulario, editable}: FormProps) => {
    return (
        <SelectField
            required={true}
            model={formulario}
            setModel={setFormulario}
            campoId='indispensable_asset'
            campoIdRespuesta='indispensable_asset_score'
            title={'¿El activo productivo es indispensable?'}
            tooltip={<>Opción seleccionada en el paso de Información de la<br></br>máquina de FinMaq Go</>}
            placeholder='Seleccione una opción'
            type={InputTypes.Text}
            editable={editable}
            options={indispensable}
        />
    )
}

const IngresosAdicionales = ({ model, setModel, editable }: FormProps) => {
    return (
        <div>
            <CheckboxField
                type={InputTypes.Boolean}
                required={true}
                model={model}
                setModel={setModel}
                campoId='invested_in_deal'
                campoIdRespuesta='invested_score'
                title={'¿Está invertido en el negocio?'}
                tooltip={<>Si el cliente selecciona 'Si' en la pregunta de ingresos<br></br>adicionales mayores al 50% en el paso de Información<br></br>de la máquina de FinMaq Go, debe elegir la opción <br></br>'No' y visceversa</>}
                opcionTrue='Sí'
                opcionFalse='No'
                editable={editable}
            />
        </div>
    );
};

const VentasAnualesDistribuidor = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <MoneyField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='annual_sales_distributor'
            placeholder='Valor de ventas del Distribuidor'
            campoIdRespuesta='distributor_sells_score'
            title={'Tamaño del distribuidor'}
            tooltip={'Consulta la hoja Distribuidores del Excel del Scoring'}
            type={InputTypes.Money}
            editable={editable}
        />
    )
}

const ComportamientoCarteraDistribuidor = ({model : formulario, setModel : setFormulario, editable}: FormProps) => {
    return (
        <SelectField
            required={true}
            model={formulario}
            setModel={setFormulario}
            campoId='credit_score_distributor'
            campoIdRespuesta='distributor_portfolio_behaviour_score'
            title={'Comportamiento cartera activa distribuidor'}
            tooltip={<>Selecciona el riesgo correspondiente de acuerdo al informe<br></br>de cartera actualizado en el Excel del Scoring en la hoja<br></br>Cartera CR</>}
            placeholder='Seleccione el comportamiento cartera activa distribuidor'
            type={InputTypes.Text}
            editable={editable}
            options={riesgo}
        />
    )
}

const Coberturas = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <NumbersField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='coverage'
            placeholder='Riesgo de cobertura'
            campoIdRespuesta='coverage_score'
            title={'Cobertura'}
            tooltip={<>Cálculo aproximado de dinero libre después de cubrir<br></br>costos y gastos. Gestiona el Excel del Scoring y consulta<br></br>el valor calculado en la hoja de Coberturas</>}
            type={InputTypes.Decimal}
            min={-10}
            max={10}
            editable={editable}
        />
    )
}